/* eslint-disable */
import CharaBase from "../../common/CharaBase";

class CharaGround extends CharaBase {
  constructor(scene) {
    super(scene);

    this.mesh = BABYLON.MeshBuilder.CreateBox(
      "ground",
      { width: 1000, height: 50, depth: 1000 },
      this.scene
    );

    this.mesh.physicsImpostor = new BABYLON.PhysicsImpostor(
      this.mesh,
      BABYLON.PhysicsImpostor.BoxImpostor,
      { mass: 0, restitution: 0.1 },
      this.scene
    );

    this.mesh.position.y = -25;
    this.mesh.visibility = 0;
  }
}
export default CharaGround;
